export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

// ISO timestamptz -> value cho <input type="datetime-local">
export function toDatetimeLocal(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
}

// value datetime-local -> ISO string
export function datetimeLocalToIso(local: string): string {
  return new Date(local).toISOString();
}

// Tên nhóm "Lưu trữ" (archive) luôn được ghim xuống cuối danh sách
const ARCHIVE_GROUP_NAME = 'lưu trữ';

// Kiểm tra một tên nhóm có phải là nhóm "Lưu trữ" hay không
export function isArchiveGroup(name: string): boolean {
  return name.trim().toLowerCase() === ARCHIVE_GROUP_NAME;
}

export function sortGroupsArchiveLast<T extends { name: string }>(
  groups: T[]
): T[] {
  return [...groups].sort((a, b) => {
    const aIsArchive = isArchiveGroup(a.name);
    const bIsArchive = isArchiveGroup(b.name);
    if (aIsArchive === bIsArchive) return 0;
    return aIsArchive ? 1 : -1;
  });
}

export type ExpiryStatus = 'none' | 'expired' | 'soon' | 'ok';

const DAY = 24 * 60 * 60 * 1000;

export function expiryStatus(expiresAt: string | null): ExpiryStatus {
  if (!expiresAt) return 'none';
  const exp = new Date(expiresAt).getTime();
  const now = Date.now();
  if (exp <= now) return 'expired';
  if (exp - now <= DAY) return 'soon';
  return 'ok';
}

// Trả về nhãn + tone cho badge hết hạn trên card
export function expiryBadge(expiresAt: string | null): {
  label: string;
  className: string;
} | null {
  const status = expiryStatus(expiresAt);
  if (status === 'none') return null;
  if (status === 'expired') {
    return { label: 'Đã hết hạn', className: 'bg-accent-100 text-accent-700' };
  }
  if (status === 'soon') {
    return {
      label: 'Sắp hết hạn',
      className: 'bg-accent-500 text-background-50 dark:text-foreground-950',
    };
  }
  return {
    label: formatDate(expiresAt as string),
    className: 'bg-background-100 text-foreground-500',
  };
}